/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_CampaignInputs */

const cs_reports_col_campaign = /** @type {(inputs: Reports_Col_CampaignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampaň`)
};

const en_reports_col_campaign = /** @type {(inputs: Reports_Col_CampaignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campaign`)
};

/**
* | output |
* | --- |
* | "Campaign" |
*
* @param {Reports_Col_CampaignInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_col_campaign = /** @type {((inputs?: Reports_Col_CampaignInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_CampaignInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_campaign(inputs)
	return cs_reports_col_campaign(inputs)
});